<template>
  <div>
    <PaymentResult v-if="getMerchant.theme == 'ZOO'"></PaymentResult>
    <NormalTemplateV2 v-else-if="getMerchant.is_special_merchant"></NormalTemplateV2>
    <NormalTemplate v-else></NormalTemplate>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NormalTemplate from './PaymentResult'
  import NormalTemplateV2 from './TicketPaymentForm'
  import PaymentResult from './custom/PaymentResult';
  
  export default {
    components:{
      NormalTemplate,
      PaymentResult,
      NormalTemplateV2
    },
    computed:{
      ...mapGetters(['getMerchant']),
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			}
    },
    mounted(){
      // The ZOO template sends its own page_view once visit_date is loaded.
      if(this.getMerchant.theme == 'ZOO') return
      this.$track('page_view', { trx_id: this.$route.params.tx_order_id })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/PaymentResultWrapper.vue